module.exports = __webpack_public_path__ + "img/background09.6c3ee3bc.jpg";